<template>
    <div id="messSendTable">
        <el-table
                :data="tableData"
                height="calc(100vh - 170px)"
                style="width: 100%"
                :header-cell-style="{backgroundColor:'#F6F8FD',height:'50px',color:'#000000',fontWeight:400,borderRadius:' 5px 5px 0px 0px'}"
                :row-style="{color:'#000000',lineHeight:'68px',height: '68px'}"
                v-loading="loading"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)"
        >
            <el-table-column
                    prop="name"
                    :label="$t('massSend.massName')"
                    min-width="120"
            >
            </el-table-column>
            <el-table-column
                    prop="channel"
                    align="left"
                    :label="$t('massSend.channel')"
                    min-width="80"
            >
                <template slot-scope="scope">
                    <div>{{scope.row | channel }}</div>
                </template>
            </el-table-column>
            <el-table-column
                    min-width="80"
                    prop="sendNumber"
                    align="center"
                    :label="$t('massSend.sendNumber')"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row | sendNumber }}</div>
                </template>
            </el-table-column>
            <el-table-column
                    min-width="80"
                    prop="creater"
                    align="center"
                    :label="$t('massSend.creator')"
            >
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.creatorInfo">{{ scope.row.creatorInfo.realName }}</span>
                        <span v-else>--</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="100"
                prop="status"
                align="center"
                :label="$t('massSend.status')"
            >
              <template slot-scope="scope">
                <div class="massStatus">
                  <div class="status takeEffect" v-if="scope.row.sendStatus === 'SENDING'">{{ $t('massSend.inEffect') }}</div>
                  <div class="status loseEffect" v-else-if="scope.row.sendStatus === 'SENT'">{{ $t('massSend.expired') }}</div>
                  <div class="status draft" v-else-if="scope.row.sendStatus === 'DRAFT'">{{ $t('massSend.draft') }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    prop="date"
                    :label="$t('massSend.date')"
                    align="center"
                    width="180"
            >
                <template slot-scope="scope">
                    <div class="create-date">
                        <i class="iconfont guoran-a-12-09"></i>
                        <span>
                            {{
                            new Date(
                            scope.row.createTime,
                            ).Format(
                            "yyyy-MM-dd hh:mm:ss",
                            )
                            }}
                        </span>

                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    :label="$t('massSend.operation')"
                    align="center"
                    width="160"
            >
                <template slot-scope="scope">
                    <div class="operation-button">
                        <el-switch
                                v-model="scope.row.open"
                                class="captcha"
                                @click.native="taskIsOpen(scope.row.open,scope.row.id)"
                                disabled
                                active-color="#366aff"
                        >
                        </el-switch>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                :content="$t('massSend.editMass')"
                                placement="top"
                        >
                          <i class="el-icon-view" v-if="scope.row.type === 'PUBLISHED' || !scope.row.type" @click="editTask(scope.row)"></i>
                          <i class="iconfont guoran-a-16-15" v-else @click="editTask(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                :content="$t('massSend.deleteMass')"
                                placement="top"
                        >
                            <i class="iconfont guoran-a-18-13" @click="deleteTask( scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                :content="$t('massSend.sendRecord')"
                                placement="top"
                        >
                            <i class="iconfont guoran-chakanshoufajilu" @click="handleClick(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="$t('massSend.copyText')"
                            placement="top"
                        >
                          <el-popover
                              placement="bottom"
                              width="200"
                              trigger="manual"
                              v-model="visible[scope.row.id]"
                          >
                            <p>{{ $t('massSend.copyTaskTip') }}</p>
                            <div style="text-align: right; margin: 0">
                              <el-button size="mini" type="text" @click="() => { $set(visible,scope.row.id,false) }">{{ $t('dragonCommon.cancel') }}</el-button>
                              <el-button type="primary" size="mini" @click="copyMass(scope.row)">{{ $t('dragonCommon.confirm') }}</el-button>
                            </div>
                            <i class="iconfont guoran-fuzhi" slot="reference" @click="$set(visible,scope.row.id,!visible[scope.row.id])"></i>
                          </el-popover>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <pagination
                :pageSize="taskPageSize"
                :currentPage="taskPage"
                :total="taskTotal"
                @handleSizeChange="handleSizeChange"
                @currentChange="handleCurrentChange">
        </pagination>
    </div>
</template>

<script>
    import pagination from "../fissionMarketing/components/pagination";
    var that
    export default {
        name: "messSendTable",
        data() {
            return {
                tableData: [],
                taskPage: 1,
                taskPageSize: 10,
                taskTotal: 0,
                loading: true,
                visible:{}
            };
        },
        components: { pagination },
        filters: {
            channel(value) {
                let channelName = "";
                if (value.channel === "WE_WORK") {
                    channelName = that.$t('massSend.' + value.channel);
                    if (value.weWorkEmployeeConfig && value.weWorkEmployeeConfig.agentName) {
                        channelName += " - " + value.weWorkEmployeeConfig.agentName;
                    }
                    return channelName;
                } else if (value.channel === "DING_TALK") {
                    channelName = that.$t('massSend.' + value.channel);
                    if (value.dingTalkAppConfig && value.dingTalkAppConfig.extInfo && value.dingTalkAppConfig.extInfo.dingTalkName) {
                        channelName += " - " + value.dingTalkAppConfig.extInfo.dingTalkName;
                    }
                    return channelName;
                } else if (value.channel === "DING_TALK_GROUP") {
                    channelName = that.$t('massSend.' + value.channel);
                    if (value.dingTalkGroupConfig && value.dingTalkGroupConfig.extInfo && value.dingTalkGroupConfig.extInfo.dingTalkGroupName) {
                        channelName += " - " + value.dingTalkGroupConfig.extInfo.dingTalkGroupName;
                    }
                    return channelName;
                } else if (value.channel === 'YUN_ZHI_JIA'){
                  channelName = that.$t('massSend.' + value.channel);
                  if (value.yunzhijiaConfig && value.yunzhijiaConfig.extInfo && value.yunzhijiaConfig.extInfo.yunzhijiaAgentName){
                    channelName += ' - ' + value.yunzhijiaConfig.extInfo.yunzhijiaAgentName
                  }
                  return channelName
                }
            },
            crodType(value) {
                if (value === "EMPLOYEE") return that.$t('massSend.' + value);
                if (value === "CUSTOMER") {
                    return that.$t('massSend.' + value);
                }
                if (value === "CUSTOMER_GROUP") {
                    return that.$t('massSend.' + value);
                }
            },
            sendNumber(value) {
                if (value) {
                  if (value.channel === 'DING_TALK' && value.dingTalkAppConfig){
                    return  value.dingTalkAppConfig.originSelectIds.length;
                  } else if (value.channel === 'DING_TALK_GROUP' && value.dingTalkGroupConfig && value.dingTalkGroupConfig.extInfo && value.dingTalkGroupConfig.extInfo.dingTalkGroupName){
                    return  value.dingTalkGroupConfig.extInfo.dingTalkGroupName.length;
                  } else if (value.channel === 'WE_WORK' && value.weWorkEmployeeConfig){
                    return  value.weWorkEmployeeConfig.originSelectIds.length;
                  } else if (value.channel === 'YUN_ZHI_JIA' && value.yunzhijiaConfig){
                    return  value.yunzhijiaConfig.originSelectIds.length;
                  } else {
                    return 0
                  }
                }
            },

        },
        methods: {
            //获取群发任务
            getTask() {
                let data = Object.assign({}, this.taskPage, {
                    page: this.taskPage - 1,
                });
                let url =
                    "/scrm-api/group-send-message-task/page?page=" +
                    data.page +
                    "&size=" +
                    this.taskPageSize;
                this.FetchGet(url).then((res) => {
                    this.tableData = res.content;
                    console.log("我是数据", this.tableData);
                    this.taskTotal = res.totalElements;
                    this.loading = false;
                });
            },
            //开启关闭任务
            taskIsOpen(value, id) {
                console.log(value);
                let url = "";
                if (!value) {
                    this.$confirm(this.$t('massSend.openTip'), this.$t('massSend.openTitle'), {
                        confirmButtonText: this.$t('common.confirm'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning",
                    }).then(() => {
                        url = "/scrm-api/group-send-message-task/open/";
                        this.FetchPut(url, id).then(res => {
                            this.$message({
                                message: this.$t('massSend.openSuccess'),
                                duration: 2000,
                                type: "success",
                            });
                            this.getTask();
                        });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: this.$t('massSend.cancelOpen'),
                        });
                    });

                } else {
                    this.$confirm(this.$t('massSend.closeTip'), this.$t('massSend.closeTitle'), {
                        confirmButtonText: this.$t('common.confirm'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning",
                    }).then(() => {
                        url = "/scrm-api/group-send-message-task/close/";
                        this.FetchPut(url, id).then(res => {
                            this.$message({
                                message: this.$t('massSend.closeSuccess'),
                                duration: 2000,
                                type: "success",
                            });
                            this.getTask();
                        });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: this.$t('massSend.cancelClose'),
                        });
                    });

                }
            },
            //查看发送记录
            handleClick(value) {
                this.$emit("handleClick", value);
            },
            //复制任务
            copyMass(row){
              this.$set(this.visible,row.id,false)
              let url = '/scrm-api/group-send-message-task/copy?id=' + row.id;
              this.$http.get(url).then(res => {
                if (res.data.code == 0){
                  this.$message({
                    message:"复制成功",
                    type:"success"
                  })
                  this.taskPage = 1;
                  this.getTask();
                } else {
                    this.$message({
                        message:res.data.msg,
                        type:"error"
                    })
                }
              }) 
            },
            //编辑任务
            editTask(item) {
              let type = (item.type === 'PUBLISHED' || !item.type ? 'PUBLISHED' : '')
              this.$router.push({ path: "taskContent", query: { taskId: item.id,type:type } });
            },
            //删除任务
            deleteTask(id) {
                this.$confirm(this.$t('massSend.deleteTip'), this.$t('massSend.deleteTitle'), {
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning",
                })
                    .then(() => {
                        let url = "/scrm-api/group-send-message-task/" + id;
                        this.FetchDelete2(url).then((res) => {
                            this.$message({
                                message: this.$t('massSend.deleteSuccess'),
                                duration: 2000,
                                type: "success",
                            });
                            this.getTask();
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: this.$t('massSend.cancelDelete'),
                        });
                    });
            },
            handleSizeChange(value) {
                this.taskPageSize = value;
                this.getTask();
            },
            handleCurrentChange(value) {
                this.taskPage = value;
                this.getTask();
            },
        },
        mounted() {
            this.getTask();
        },
        beforeCreate() {
          that = this
        }
    };
</script>

<style scoped lang="less">
    #messSendTable {
        /*position: relative;*/
        display: flex;
        align-items: center;
      flex: 1;
      height: calc(100vh - 172px);
      .el-icon-view{
        font-size: 18px;
      }
      .el-table{
        position: absolute;
      }
        /*width: calc(100vw - 90px);*/

        .create-date {
            display: flex;
            align-items: center;

            .guoran-a-12-09 {
                padding-right: 10px;
                color: #D2D8E3;
                font-size: 14px;
            }
        }

        .operation-button {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #366AFF;
            width: 100%;
            .el-switch.is-disabled {
                opacity: 1 !important;
            }

            .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label {
                cursor: pointer !important;
            }
            .disabled-icon{
              color: #999999!important;
            }
        }
        /deep/.el-pagination{
            padding: 2px 5px!important;
        }
      .massStatus{
        display: flex;
        align-items: center;
        justify-content: center;
        .status{
          height: 20px;
          padding: 0 10px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }
        .takeEffect{
          background: #F5F8FF;
          color: #366AFF;
        }
        .loseEffect{
          background: #FFEBEC;
          color: #FE5965;
        }
        .draft{
          background: #E6F8EB;
          color: #18AF43;;
        }
      }
    }
</style>